import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../../Utils/Utils'
import OneModal from "../../../../Components/OneModal/OneModal"
import OneSelectCor from "../../../../Components/OneSelectCor/OneSelectCor"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"

export const CadastroTag = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setInitialData(msg.data.tag)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    useEffect(() => {
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            setLoading(true)
            addRoute("buscarTag", getDadosIniciais)
            sendWs("buscarTag", { id: idToEdit, listar: true })
        } else {
            setLoading(false)
        }
    }, [])

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            setIdToEdit(null)
            setOpenCadastro(false)
            showNotify("success", "Tag salva com sucesso!")
            sendWs("buscarTodasTags")
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("criarTag", responseSumbit)
    addRoute("editarTag", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            setOpenCadastro(false)
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            sendWs("editarTag", { tag: data })
        } else {
            delete data.id
            sendWs("criarTag", { tag: data })
        }
    }

    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            loading={loading}
            titleText="Tags"
            FooterButtons={FooterButtons}
        >
            {!loading &&
            <form
                id="tags-form"
                onSubmit={handleSubmit}
            >
                <Grid
                    xs={12}
                    rowSpacing={0}
                    columnSpacing={1}
                    container
                    gap={0.5}
                    sx={{ maxWidth: '500px' }}
                >
                    <Grid container xs={12} rowGap={2} sx={{ alignItems: 'center' }}>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={5} sx={{ alignItems: 'center' }}>
                                <Grid xs={3} sm={4.7}>
                                    <Typography fontSize="13px" fontWeight='400' >Código: </Typography>
                                </Grid>
                                <Grid xs={9} sm={6}>
                                    <OneInput defaultValue={initialData?.id} onChange={handleChange} readOnly={true} disabled={true} name={"id"}/>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={4} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={2}>
                                    <Typography fontSize="13px" fontWeight='400' >Cor: </Typography>
                                </Grid>
                                <Grid xs={12} sm={9} lg={9}>
                                    <OneSelectCor defaultValue={initialData?.cor} onChange={handleChange} name={"cor"} />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={3} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={4} lg={4}>
                                    <Typography fontSize="13px" fontWeight='400' >Ativo: </Typography>
                                </Grid>
                                <Grid xs={12} sm={4} lg={4}>
                                    <OneSwitch defaultChecked={initialData?.ativo} onChange={handleChange} name={"ativo"} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={2}>
                                    <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                                </Grid>
                                <Grid xs={12} sm lg>
                                    <OneInput
                                        defaultValue={initialData?.descricao}
                                        onChange={handleChange}
                                        autoFocus
                                        maxLength="55"
                                        required
                                        name={"descricao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            }
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="tags-form" type="submit">Salvar</Button>
        </Grid>
    )
}
